// removed by extract-text-webpack-plugin
module.exports = {"StartChattingButtonWrapper":"StartChattingButtonWrapper__2aCy0","StartChattingButton":"StartChattingButton__1WND1","StartChattingText":"StartChattingText__1RKYW"};


//////////////////
// WEBPACK FOOTER
// ./routes/GDPROverlay/style.scss
// module id = 0ze8
// module chunks = 0